// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu_menuContainer__3graH","formContainer":"menu_formContainer__28itk","checkboxContainer":"menu_checkboxContainer__3Dngx"};